import { IconProps } from 'types';

const AlertTriangleFilled = ({ title = 'Alert Triangle Filled', className }: IconProps) => (
    <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <title>{title}</title>
        <path
            d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
            fill="currentColor"
        />
        <path
            d="M12 9v4"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <circle
            cx="12"
            cy="17"
            r="1"
            fill="white"
        />
    </svg>
);

export default AlertTriangleFilled;
